import React from 'react';
import { string, arrayOf } from 'prop-types';
import './key-takeaways-card.m.css';

export const KeyTakeawaysCard = ({
  title = "Key Takeaways",
  takeaways = [],
  className
}) => {
  // Extract text content from HTML string
  const extractTakeawayItems = (htmlString) => {
    if (!htmlString) return [];

    // Use regex to extract text content from <p> tags within <li> tags
    const regex = /<li><p>(.*?)<\/p><\/li>/g;
    const items = [];
    let match;

    while ((match = regex.exec(htmlString)) !== null) {
      items.push(match[1]);
    }

    return items;
  };

  // Process takeaways data - handle both HTML string format and plain text array
  const processTakeaways = () => {
    if (!takeaways || takeaways.length === 0) return [];

    // If first item is HTML string (contains <ul>)
    if (typeof takeaways[0] === 'string' && takeaways[0].includes('<ul>')) {
      return extractTakeawayItems(takeaways[0]);
    }

    // If it's already an array of strings
    return takeaways.filter(item => item && typeof item === 'string' && item.trim());
  };

  const takeawayItems = processTakeaways();

  // Don't render if no valid items
  if (!takeawayItems || takeawayItems.length === 0) {
    return null;
  }

  return (
    <div styleName="key-takeaways-section" data-section="key-takeaways">
      <div styleName={`key-takeaways-card ${className || ''}`}>
        <div styleName="key-takeaways-content">
          <div styleName="key-takeaways-header">
            <h2 styleName="key-takeaways-title">{title}</h2>
          </div>
          <div styleName="key-takeaways-grid">
            {takeawayItems.map((takeaway, index) => (
              <div key={index} styleName="key-takeaway-item">
                <p>{takeaway}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

KeyTakeawaysCard.propTypes = {
  title: string,
  takeaways: arrayOf(string),
  className: string,
};